/**
 * With the CRM open in several tabs, only one plays sounds and desktop
 * alerts. The first tab to take the Web Lock leads until it closes; then
 * another tab takes over. Browsers without Web Locks: every tab leads.
 */
let leader = false;
let requested = false;

export const claimNotificationLeadership = () => {
  if (requested || typeof navigator === "undefined") return;
  requested = true;
  const locks = (
    navigator as Navigator & {
      locks?: {
        request: (name: string, cb: () => Promise<void>) => Promise<void>;
      };
    }
  ).locks;
  if (!locks) {
    leader = true;
    return;
  }
  void locks.request(
    "nomi-notifications-leader",
    () =>
      new Promise<void>(() => {
        // Held until the tab closes.
        leader = true;
      }),
  );
};

export const isNotificationLeader = () => {
  claimNotificationLeadership();
  return leader;
};
